import * as React from "react";
const Newspaper = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 14h10v1H7v-1Zm10-6h-4v1h4V8Zm-4 3h4v1h-4v-1ZM7 8h4v4H7V8Zm1 1v2h2V9H8Z" }), /* @__PURE__ */ React.createElement("path", { d: "M5 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm14 1v12H5V6h14Z" }));
Newspaper.displayName = "Newspaper";
var Newspaper_default = Newspaper;
export {
  Newspaper_default as default
};
